/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminChatAttachmentResponse,
  AdminChatDrillRequest,
  AdminChatDrillResponse,
  AdminChatImageRequest,
  AdminChatVideoRequest,
  AdminPlayerData,
  AdminProfile,
  AdminUserInviteRequest,
  AdminUserInviteResponse,
  AdminV1OrganizationsPaymentsOfferingsPlayerDataRetrieveParams,
  AdminV1OrganizationsPlayerDataByProfileIdRetrieveParams,
  AdminV1OrganizationsPlayerDataListParams,
  AdminV1ProfilesListParams,
  AdminV1WaffleStatusRetrieve200,
  AdminV1WaffleStatusRetrieveParams,
  CalendarFeed,
  CalendarFeedList,
  CalendarFeedRotate,
  OfferingStatistics,
  PaginatedAdminPlayerDataList,
  PaginatedAdminProfileList,
  PatchedAdminPlayerData,
  PatchedAdminSelfProfileUpdate,
  SendbirdToken
} from '.././model';

import adminV1InviteUsersCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsGroupChannelsDrillCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsGroupChannelsImageAssetCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsGroupChannelsVideoAssetCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsCalendarFeedsRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsCalendarFeedsRotateCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsOfferingsPlayerDataRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsOfferingsStatisticsRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPlayerDataListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPlayerDataCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPlayerDataRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPlayerDataUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPlayerDataPartialUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPlayerDataDestroyMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPlayerDataByProfileIdRetrieveMutator from '../../shared/services/axios-client';
import adminV1ProfilesListMutator from '../../shared/services/axios-client';
import adminV1ProfilesRetrieveMutator from '../../shared/services/axios-client';
import adminV1ProfilesPartialUpdateMutator from '../../shared/services/axios-client';
import adminV1SendbirdTokenCreateMutator from '../../shared/services/axios-client';
import adminV1WaffleStatusRetrieveMutator from '../../shared/services/axios-client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Invite one or more users to join the organization. Creates user accounts and sends invitation emails.
 * @summary Invite one or more users to join the organization. Creates user accounts and sends invitation emails.
 */
export const adminV1InviteUsersCreate = (
    adminUserInviteRequest: AdminUserInviteRequest,
 options?: SecondParameter<typeof adminV1InviteUsersCreateMutator<AdminUserInviteResponse>>,) => {
      return adminV1InviteUsersCreateMutator<AdminUserInviteResponse>(
      {url: `/api/admin/v1/invite-users/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminUserInviteRequest
    },
      options);
    }
  /**
 * 
        Creates the chat message and posts the drill to the channel. A drill carries no upload,
        so the message is final on the first send and nothing further happens asynchronously.

        A 502 means the drill did not reach Sendbird. Nothing is created in that case, so the
        request can simply be retried.
        
 * @summary Post a drill to an admin chat's Sendbird channel
 */
export const adminV1OrganizationsGroupChannelsDrillCreate = (
    organizationId: number,
    channelUrl: string,
    adminChatDrillRequest: AdminChatDrillRequest,
 options?: SecondParameter<typeof adminV1OrganizationsGroupChannelsDrillCreateMutator<AdminChatDrillResponse>>,) => {
      return adminV1OrganizationsGroupChannelsDrillCreateMutator<AdminChatDrillResponse>(
      {url: `/api/admin/v1/organizations/${organizationId}/group-channels/${channelUrl}/drill/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminChatDrillRequest
    },
      options);
    }
  /**
 * 
        Creates the chat message, its Sendbird channel message, and an upload ticket, then posts a
        placeholder message to the channel straight away.

        **Workflow:**
        1. Post here to get `upload_ticket.upload_url` (or `upload_ticket.multipart_urls`)
        2. Upload the file to S3 with the returned URL(s)
        3. For a multipart upload, finish with
           POST /admin/organizations/{organization_id}/upload-tickets/{id}/complete_multipart/
        4. Upload completion replaces the placeholder message with the finished attachment and
           links the asset to the chat message — no further call is needed

        A 502 means the placeholder message did not reach Sendbird. Nothing is created in that
        case, so the request can simply be retried.

        An image is never transcoded, so its ticket completes as soon as the file lands in S3 and
        the finished image message follows within seconds.
        
 * @summary Post an image to an admin chat's Sendbird channel
 */
export const adminV1OrganizationsGroupChannelsImageAssetCreate = (
    organizationId: number,
    channelUrl: string,
    adminChatImageRequest: AdminChatImageRequest,
 options?: SecondParameter<typeof adminV1OrganizationsGroupChannelsImageAssetCreateMutator<AdminChatAttachmentResponse>>,) => {
      return adminV1OrganizationsGroupChannelsImageAssetCreateMutator<AdminChatAttachmentResponse>(
      {url: `/api/admin/v1/organizations/${organizationId}/group-channels/${channelUrl}/image-asset/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminChatImageRequest
    },
      options);
    }
  /**
 * 
        Creates the chat message, its Sendbird channel message, and an upload ticket, then posts a
        placeholder message to the channel straight away.

        **Workflow:**
        1. Post here to get `upload_ticket.upload_url` (or `upload_ticket.multipart_urls`)
        2. Upload the file to S3 with the returned URL(s)
        3. For a multipart upload, finish with
           POST /admin/organizations/{organization_id}/upload-tickets/{id}/complete_multipart/
        4. Upload completion replaces the placeholder message with the finished attachment and
           links the asset to the chat message — no further call is needed

        A 502 means the placeholder message did not reach Sendbird. Nothing is created in that
        case, so the request can simply be retried.

 * @summary Post a video to an admin chat's Sendbird channel
 */
export const adminV1OrganizationsGroupChannelsVideoAssetCreate = (
    organizationId: number,
    channelUrl: string,
    adminChatVideoRequest: AdminChatVideoRequest,
 options?: SecondParameter<typeof adminV1OrganizationsGroupChannelsVideoAssetCreateMutator<AdminChatAttachmentResponse>>,) => {
      return adminV1OrganizationsGroupChannelsVideoAssetCreateMutator<AdminChatAttachmentResponse>(
      {url: `/api/admin/v1/organizations/${organizationId}/group-channels/${channelUrl}/video-asset/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminChatVideoRequest
    },
      options);
    }
  /**
 * Lists and rotates the subscribable calendar feeds backing the share sidepanel.

Accessed via /admin/organizations/{organization_id}/payments/calendar-feeds/
 * @summary Lists and rotates the subscribable calendar feeds backing the share sidepanel.
 */
export const adminV1OrganizationsPaymentsCalendarFeedsRetrieve = (
    organizationId: number,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsCalendarFeedsRetrieveMutator<CalendarFeedList>>,) => {
      return adminV1OrganizationsPaymentsCalendarFeedsRetrieveMutator<CalendarFeedList>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/calendar-feeds/`, method: 'GET'
    },
      options);
    }
  /**
 * Lists and rotates the subscribable calendar feeds backing the share sidepanel.

Accessed via /admin/organizations/{organization_id}/payments/calendar-feeds/
 * @summary Lists and rotates the subscribable calendar feeds backing the share sidepanel.
 */
export const adminV1OrganizationsPaymentsCalendarFeedsRotateCreate = (
    organizationId: number,
    calendarFeedRotate: CalendarFeedRotate,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsCalendarFeedsRotateCreateMutator<CalendarFeed>>,) => {
      return adminV1OrganizationsPaymentsCalendarFeedsRotateCreateMutator<CalendarFeed>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/calendar-feeds/rotate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: calendarFeedRotate
    },
      options);
    }
  /**
 * Export player data for all subscribers of an offering in CSV format.
 * @summary Export player data for all subscribers of an offering in CSV format.
 */
export const adminV1OrganizationsPaymentsOfferingsPlayerDataRetrieve = (
    organizationId: number,
    id: string,
    params?: AdminV1OrganizationsPaymentsOfferingsPlayerDataRetrieveParams,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsOfferingsPlayerDataRetrieveMutator<Blob>>,) => {
      return adminV1OrganizationsPaymentsOfferingsPlayerDataRetrieveMutator<Blob>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/offerings/${id}/player-data/`, method: 'GET',
        params,
        responseType: 'blob'
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsOfferingsStatisticsRetrieve = (
    organizationId: number,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsOfferingsStatisticsRetrieveMutator<OfferingStatistics>>,) => {
      return adminV1OrganizationsPaymentsOfferingsStatisticsRetrieveMutator<OfferingStatistics>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/offerings/${id}/statistics/`, method: 'GET'
    },
      options);
    }
  /**
 * Admin API endpoint for PlayerData.
Provides access to PlayerData.
 * @summary Admin API endpoint for PlayerData.
Provides access to PlayerData.
 */
export const adminV1OrganizationsPlayerDataList = (
    organizationId: number,
    params?: AdminV1OrganizationsPlayerDataListParams,
 options?: SecondParameter<typeof adminV1OrganizationsPlayerDataListMutator<PaginatedAdminPlayerDataList>>,) => {
      return adminV1OrganizationsPlayerDataListMutator<PaginatedAdminPlayerDataList>(
      {url: `/api/admin/v1/organizations/${organizationId}/player-data/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Admin API endpoint for PlayerData.
Provides access to PlayerData.
 * @summary Admin API endpoint for PlayerData.
Provides access to PlayerData.
 */
export const adminV1OrganizationsPlayerDataCreate = (
    organizationId: number,
    adminPlayerData: NonReadonly<AdminPlayerData>,
 options?: SecondParameter<typeof adminV1OrganizationsPlayerDataCreateMutator<AdminPlayerData>>,) => {
      return adminV1OrganizationsPlayerDataCreateMutator<AdminPlayerData>(
      {url: `/api/admin/v1/organizations/${organizationId}/player-data/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminPlayerData
    },
      options);
    }
  /**
 * Admin API endpoint for PlayerData.
Provides access to PlayerData.
 * @summary Admin API endpoint for PlayerData.
Provides access to PlayerData.
 */
export const adminV1OrganizationsPlayerDataRetrieve = (
    organizationId: number,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsPlayerDataRetrieveMutator<AdminPlayerData>>,) => {
      return adminV1OrganizationsPlayerDataRetrieveMutator<AdminPlayerData>(
      {url: `/api/admin/v1/organizations/${organizationId}/player-data/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * Admin API endpoint for PlayerData.
Provides access to PlayerData.
 * @summary Admin API endpoint for PlayerData.
Provides access to PlayerData.
 */
export const adminV1OrganizationsPlayerDataUpdate = (
    organizationId: number,
    id: string,
    adminPlayerData: NonReadonly<AdminPlayerData>,
 options?: SecondParameter<typeof adminV1OrganizationsPlayerDataUpdateMutator<AdminPlayerData>>,) => {
      return adminV1OrganizationsPlayerDataUpdateMutator<AdminPlayerData>(
      {url: `/api/admin/v1/organizations/${organizationId}/player-data/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminPlayerData
    },
      options);
    }
  /**
 * Admin API endpoint for PlayerData.
Provides access to PlayerData.
 * @summary Admin API endpoint for PlayerData.
Provides access to PlayerData.
 */
export const adminV1OrganizationsPlayerDataPartialUpdate = (
    organizationId: number,
    id: string,
    patchedAdminPlayerData: NonReadonly<PatchedAdminPlayerData>,
 options?: SecondParameter<typeof adminV1OrganizationsPlayerDataPartialUpdateMutator<AdminPlayerData>>,) => {
      return adminV1OrganizationsPlayerDataPartialUpdateMutator<AdminPlayerData>(
      {url: `/api/admin/v1/organizations/${organizationId}/player-data/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminPlayerData
    },
      options);
    }
  /**
 * Admin API endpoint for PlayerData.
Provides access to PlayerData.
 * @summary Admin API endpoint for PlayerData.
Provides access to PlayerData.
 */
export const adminV1OrganizationsPlayerDataDestroy = (
    organizationId: number,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsPlayerDataDestroyMutator<void>>,) => {
      return adminV1OrganizationsPlayerDataDestroyMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/player-data/${id}/`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieve player data for a specific profile. Returns JSON by default, or CSV when Accept header is 'text/csv'.
 * @summary Get PlayerData by profile ID
 */
export const adminV1OrganizationsPlayerDataByProfileIdRetrieve = (
    organizationId: number,
    profileId: string,
    params?: AdminV1OrganizationsPlayerDataByProfileIdRetrieveParams,
 options?: SecondParameter<typeof adminV1OrganizationsPlayerDataByProfileIdRetrieveMutator<AdminPlayerData | Blob>>,) => {
      return adminV1OrganizationsPlayerDataByProfileIdRetrieveMutator<AdminPlayerData | Blob>(
      {url: `/api/admin/v1/organizations/${organizationId}/player-data/by-profile-id/${profileId}/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Viewset for global profile endpoints that don't require organization
context. Only supports retrieving the current user's profile via
/profiles/me
 * @summary Viewset for global profile endpoints that don't require organization
context. Only supports retrieving the current user's profile via
/profiles/me
 */
export const adminV1ProfilesList = (
    params?: AdminV1ProfilesListParams,
 options?: SecondParameter<typeof adminV1ProfilesListMutator<PaginatedAdminProfileList>>,) => {
      return adminV1ProfilesListMutator<PaginatedAdminProfileList>(
      {url: `/api/admin/v1/profiles/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Viewset for global profile endpoints that don't require organization
context. Only supports retrieving the current user's profile via
/profiles/me
 * @summary Viewset for global profile endpoints that don't require organization
context. Only supports retrieving the current user's profile via
/profiles/me
 */
export const adminV1ProfilesRetrieve = (
    id: number,
 options?: SecondParameter<typeof adminV1ProfilesRetrieveMutator<AdminProfile>>,) => {
      return adminV1ProfilesRetrieveMutator<AdminProfile>(
      {url: `/api/admin/v1/profiles/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * Update the current user's own profile (name, phone, preferred auth method, avatar).
 * @summary Update the current user's own profile (name, phone, preferred auth method, avatar).
 */
export const adminV1ProfilesPartialUpdate = (
    id: number,
    patchedAdminSelfProfileUpdate: PatchedAdminSelfProfileUpdate,
 options?: SecondParameter<typeof adminV1ProfilesPartialUpdateMutator<AdminProfile>>,) => {
      return adminV1ProfilesPartialUpdateMutator<AdminProfile>(
      {url: `/api/admin/v1/profiles/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminSelfProfileUpdate
    },
      options);
    }
  /**
 * Create a Sendbird user token for the authenticated user's profile
 * @summary Create a Sendbird user token for the authenticated user's profile
 */
export const adminV1SendbirdTokenCreate = (
    
 options?: SecondParameter<typeof adminV1SendbirdTokenCreateMutator<SendbirdToken>>,) => {
      return adminV1SendbirdTokenCreateMutator<SendbirdToken>(
      {url: `/api/admin/v1/sendbird/token/`, method: 'POST'
    },
      options);
    }
  /**
 * Returns the current status of all Waffle flags, switches, and samples. By default flags are evaluated for the authenticated user. When an 'organization' ID query parameter is supplied, flags are instead evaluated for that organization, so network admins impersonating an organization see flag state as that organization's members do. In organization mode a flag is active when its 'everyone' setting is on, or when the organization is attached to the flag; a flag with 'everyone' off is inactive regardless of attachment. Per-user flag conditions (specific users, groups, percentage rollouts, staff/superuser) are not represented, and switches and samples remain global. Reading another organization requires staff, or an admin whose own organization belongs to the same network hierarchy as the target: an admin of the organization itself, a network admin whose hierarchy contains it, or an admin of another organization in the same network.
 * @summary Get Waffle feature flags status
 */
export const adminV1WaffleStatusRetrieve = (
    params?: AdminV1WaffleStatusRetrieveParams,
 options?: SecondParameter<typeof adminV1WaffleStatusRetrieveMutator<AdminV1WaffleStatusRetrieve200>>,) => {
      return adminV1WaffleStatusRetrieveMutator<AdminV1WaffleStatusRetrieve200>(
      {url: `/api/admin/v1/waffle_status/`, method: 'GET',
        params
    },
      options);
    }
  export type AdminV1InviteUsersCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1InviteUsersCreate>>>
export type AdminV1OrganizationsGroupChannelsDrillCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsGroupChannelsDrillCreate>>>
export type AdminV1OrganizationsGroupChannelsImageAssetCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsGroupChannelsImageAssetCreate>>>
export type AdminV1OrganizationsGroupChannelsVideoAssetCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsGroupChannelsVideoAssetCreate>>>
export type AdminV1OrganizationsPaymentsCalendarFeedsRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsCalendarFeedsRetrieve>>>
export type AdminV1OrganizationsPaymentsCalendarFeedsRotateCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsCalendarFeedsRotateCreate>>>
export type AdminV1OrganizationsPaymentsOfferingsPlayerDataRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsOfferingsPlayerDataRetrieve>>>
export type AdminV1OrganizationsPaymentsOfferingsStatisticsRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsOfferingsStatisticsRetrieve>>>
export type AdminV1OrganizationsPlayerDataListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPlayerDataList>>>
export type AdminV1OrganizationsPlayerDataCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPlayerDataCreate>>>
export type AdminV1OrganizationsPlayerDataRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPlayerDataRetrieve>>>
export type AdminV1OrganizationsPlayerDataUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPlayerDataUpdate>>>
export type AdminV1OrganizationsPlayerDataPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPlayerDataPartialUpdate>>>
export type AdminV1OrganizationsPlayerDataDestroyResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPlayerDataDestroy>>>
export type AdminV1OrganizationsPlayerDataByProfileIdRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPlayerDataByProfileIdRetrieve>>>
export type AdminV1ProfilesListResult = NonNullable<Awaited<ReturnType<typeof adminV1ProfilesList>>>
export type AdminV1ProfilesRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1ProfilesRetrieve>>>
export type AdminV1ProfilesPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1ProfilesPartialUpdate>>>
export type AdminV1SendbirdTokenCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1SendbirdTokenCreate>>>
export type AdminV1WaffleStatusRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1WaffleStatusRetrieve>>>
